/* global LOGIN_URL */

export const SET_USER = 'SET_USER';

export function setUser(user) {
  return {
    type: SET_USER,
    user,
  };
}

export function fetchMe(withRoles = false) {
  return (dispatch, _, {userApi, bugsnagService}) =>
    userApi.me(withRoles)
      .then(response => {
        switch (response.status) {
          case 200:
            return response.json()
              .then(json => {
                bugsnagService.setUser(json);
                dispatch(setUser(json));
                return json;
              });
          case 401:
            window.location.href = `${LOGIN_URL}login/` +
              `?next=${encodeURIComponent(window.location.href)}`;
            return null;
          default:
            throw response;
        }
      });
}

export const fetchMeWithRoles = () => fetchMe(true);



// WEBPACK FOOTER //
// ./src/common/actions/user.js